import { DatePickerInput } from '@mantine/dates';
import { useTranslation } from 'locales';

import { useInvoiceFormContext } from '../InvoiceForm.context';
import { getDefaultIssueDate } from '../InvoiceForm.utils';

type IssueDateFieldProps = {
  onChange: (value: string | null) => void;
};

export const IssueDateField = ({ onChange }: IssueDateFieldProps) => {
  const { currentLang } = useTranslation();
  const form = useInvoiceFormContext();

  const defaultDate = getDefaultIssueDate();

  return (
    <DatePickerInput
      value={form.values.issue_date}
      onChange={onChange}
      error={form.errors.issue_date}
      locale={currentLang}
      placeholder={defaultDate.format('L')}
    />
  );
};
